export * from './slug.pipe';



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/core/pipes/index.ts